import appLogger from "../../infra/logger/appLogger";
const databricksLogger = appLogger.withTag("Databricks");
export default databricksLogger;
